import Section from '../Section'
import './FifthSection.scss'
import TeamMember from './TeamMember'

import g from '../../images/g.jpeg';
import ag from '../../images/ag.jpg';

const FifthSection = () => {
  return (
    <div id="team">
      <Section title={'Conheça nossa equipe:'}>
        <div className="fifth-section-content">
          <div className="fifth-section-team-members">
            <div className="g">
              <TeamMember
                name={'Gabriela Barros'}
                role={'Técnica processual'}
                description={'Graduada em direito pela UFRJ, assessora jurídica especializada em processo de registro de marca e procuradora do INPI.'}
                imgUrl={g}
              />
            </div>

            <div className="ag">
              <TeamMember
                name={'Augusto Leão'}
                role={'Comercial'}
                description={'Graduado em Direito pela UFRJ, estudante de Propriedade Intelectual, especialista em registro de marcas e Head Comercial da SPOT.'}
                imgUrl={ag}
              />
            </div>
          </div>
        </div>
      </Section>
    </div>
  )
}

export default FifthSection